import gql from 'graphql-tag';

export const GET_EXERCISE_WITH_DISCIPLINES_AND_SERIES = gql`
  query GetExerciseWithDisciplinesAndSeries {
    exercisesWithDisciplinesAndSeries {
      _id
      description
      duration
      name
      position
      series {
        _id
        name
      }
      questions {
        _id
        description
        image
        name
        type
        responses {
          isRight
          key
          response
        }
        series {
          _id
          name
        }
      }
      discipline {
        _id
        name
      }
    }
  }
`;
